import React from "react";
import { Link } from "react-router-dom";
import { t } from "i18next";

const Path = ({ currentPath, pathTo = "/" }) => {
  const pathnames = (currentPath || "").split("/").filter((x) => x);

  return (
    <nav
      aria-label="breadcrumb"
      className="hidden md:flex w-full bg-white border-b border-gray-100 items-center px-[60px] lg:px-[120px] xl:px-[240px] py-3"
    >
      <ol className="flex items-center list-none m-0 p-0 flex-wrap gap-y-1">
        <li className="flex items-center">
          <Link to="/" className="text-sm text-gray-400 hover:text-[#147F26] transition-colors no-underline">
            {t("home")}
          </Link>
        </li>

        {pathnames.map((value, index) => {
          const to = `${pathTo}/${pathnames.slice(1, index + 1).join("/")}`;
          const displayLabel = value === "null" ? t("all") : value;
          const isActive = index === pathnames.length - 1;

          return (
            <li key={to} className="flex items-center">
              <span className="mx-2 text-gray-300 text-sm">/</span>
              {isActive ? (
                <span className="text-sm text-gray-800 font-medium">{displayLabel}</span>
              ) : (
                <Link to={to} className="text-sm text-gray-400 hover:text-[#147F26] transition-colors no-underline">
                  {displayLabel}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Path;
